<template>
  <a-modal v-model:visible="modal.show" :footer="null"
           wrapClassName="modal_video" destroyOnClose>
    <video ref="video" :src="modal.href"
           :muted="false" controls preload autoplay loop />
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'page_modalVideo',
  data(): DataInterface {
    return {
      modal: {
        show: false,
        href: ''
      }
    };
  },
  methods: {
    /**
     * 开启
     * @param {string} href 链接
     */
    open(href: string): void {
      this.modal.show = true;
      this.modal.href = href;
    },
    
    /**
     * 关闭
     */
    close(): void {
      this.modal.show = false;
      this.modal.href = '';
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
@import '@resource/css/_global.less';

@image: '@{src_image}';

.modal_video {
  .ant-modal {
    width: 1200px !important;
    max-width: 90%;
    
    .ant-modal-body {
      padding: 10px;
    }
    
    .ant-modal-close {
      right: -40px;
      width: 30px;
      height: 30px;
      color: @color_black;
      background-color: fade(@color_white, 80);
      .transition(background-color @time);
      
      &:hover {
        background-color: fade(@color_white, 100);
      }
      
      .ant-modal-close-x {
        position: relative;
        width: 100%;
        height: 100%;
        
        .ant-modal-close-icon {
          .position();
          width: 16px;
          height: 16px;
          margin: auto;
        }
      }
    }
  }
  
  video {
    display: block;
    width: 100%;
    background: @color_5;
    border-radius: 5px;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .modal_video {
    .ant-modal {
      .ant-modal-close {
        .position(bottom, -40px);
        margin: 0 auto;
      }
    }
  }
}
</style>